import { HexalInstance } from '@common/enums';
import { Feedback } from '@common/types';
import useIsMobile from '@hooks/use-is-mobile';
import { cn, CURRENT_INSTANCE } from '@lib/utils';
import { ThumbsDown, ThumbsUp } from 'lucide-react';

interface IFeedbackPanelProps {
  submit: (feedback: Feedback) => void;
}

function FeedbackPanel(props: IFeedbackPanelProps) {
  const isMobile = useIsMobile();
  const iconSize = isMobile ? 24 : 28;

  return (
    <div className="flex items-center gap-3">
      <ThumbsUp
        width={iconSize}
        height={iconSize}
        className={cn(
          'cursor-pointer text-xircle-main hover:text-xircle-secondary',
          CURRENT_INSTANCE.name === HexalInstance.Default && 'hover:text-xircle-main-soft'
        )}
        onClick={() => props.submit(Feedback.Like)}
      />
      <ThumbsDown
        width={iconSize}
        height={iconSize}
        className={cn(
          'cursor-pointer text-xircle-main hover:text-xircle-secondary thumbs-down',
          CURRENT_INSTANCE.name === HexalInstance.Default && 'hover:text-xircle-main-soft'
        )}
        onClick={() => props.submit(Feedback.Dislike)}
      />
    </div>
  );
}

export default FeedbackPanel;
